import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  MajorCategory,
  industryData,
  subCategories,
} from "@/config/industry-code";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const initialMajorCategory = Object.keys(industryData)[0] as MajorCategory;
const initialSubCategory = industryData[initialMajorCategory].codes[0];

const IndustrySelector = ({
  className,
  onIndustryCodeChange,
  error,
}: {
  className?: string;
  onIndustryCodeChange?: (code: string) => void;
  error?: string;
}) => {
  const [selectedMajorCategory, setSelectedMajorCategory] =
    useState<MajorCategory>(initialMajorCategory);
  const [selectedSubCategory, setSelectedSubCategory] =
    useState<string>(initialSubCategory);

  const { t } = useTranslation();

  const availableSubCategories = useMemo(() => {
    if (!selectedMajorCategory) return [];
    return selectedMajorCategory in industryData
      ? industryData[selectedMajorCategory].codes
      : [];
  }, [selectedMajorCategory]);

  useEffect(() => {
    if (selectedMajorCategory && selectedSubCategory) {
      onIndustryCodeChange &&
        onIndustryCodeChange(`${selectedMajorCategory}${selectedSubCategory}`);
    }
  }, [selectedMajorCategory, selectedSubCategory]);

  const handleMajorCategoryChange = (value: MajorCategory) => {
    setSelectedMajorCategory(value);
    setSelectedSubCategory("");
  };

  return (
    <div className={`flex flex-col space-y-1 ${className}`}>
      <div className={`space-x-4 w-full flex flex-row`}>
        <div className="space-y-2 flex-1">
          <Label label={t("major-category")}>{t("major-category")}</Label>
          <Select
            value={selectedMajorCategory}
            onValueChange={handleMajorCategoryChange}
          >
            <SelectTrigger className=" border border-input rounded-md bg-background">
              <SelectValue placeholder={t("select-major-category")} />
            </SelectTrigger>
            <SelectContent>
              {(Object.keys(industryData) as MajorCategory[]).map((key) => (
                <SelectItem key={key} value={key}>
                  {/* {key} - {industryData[key].name} */}
                  {industryData[key].name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2 flex-1">
          <Label label={t("medium-classification")}>
            {t("medium-classification")}
          </Label>
          <Select
            value={selectedSubCategory}
            onValueChange={setSelectedSubCategory}
            disabled={!selectedMajorCategory}
          >
            <SelectTrigger className=" border border-input rounded-md bg-background">
              <SelectValue placeholder={t("select-medium-classification")} />
            </SelectTrigger>
            <SelectContent>
              {availableSubCategories.map((code) => (
                <SelectItem key={code} value={code}>
                  {/* {code} - {subCategories[code]} */}
                  {subCategories[code]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
};

export default IndustrySelector;
